"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decapitalizeFirstLetter = void 0;
const decapitalizeFirstLetter = (str) => {
    if (!str)
        return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
};
exports.decapitalizeFirstLetter = decapitalizeFirstLetter;
